// extracted by mini-css-extract-plugin
export default {"challengesContainer":"styles_challengesContainer__oaVAL","emptyCard":"styles_emptyCard__EFXYE"};